import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Radio, Gavel, Users, Flame, ShieldCheck } from 'lucide-react';

export default function About() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <div className="flex-1 max-w-5xl mx-auto w-full px-4 sm:px-6 py-12">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-rose-500/10 border border-rose-500/30 text-rose-300 text-xs font-semibold uppercase tracking-widest">
          À propos
        </div>
        <h1 className="mt-4 font-display font-extrabold text-4xl sm:text-5xl leading-tight">
          Le live shopping sénégalais,{' '}
          <span className="bg-gradient-to-r from-rose-500 via-amber-400 to-rose-500 bg-clip-text text-transparent">réinventé</span>.
        </h1>
        <p className="mt-5 text-slate-300 text-base sm:text-lg max-w-3xl leading-relaxed">
          JOTALY rassemble les meilleurs vendeurs du Sénégal — boutiques mode, friperies, coiffeuses, revendeurs d'électronique, artisans et commerçants de tous secteurs — et leurs clients autour de lives d'enchères palpitants.
          Tout produit légal peut être vendu : mode, beauté, téléphones, maison, alimentation et pièces uniques — chaque jour, de nouvelles ventes en direct.
        </p>

        <div className="mt-12 grid md:grid-cols-3 gap-4">
          {[
            { icon: <Gavel className="h-5 w-5" />, title: 'Enchères en direct', text: 'Un timer, un bouton. Le meilleur enchérisseur gagne. Fiable, transparent, addictif.' },
            { icon: <Radio className="h-5 w-5" />, title: 'Lives natifs', text: 'Les vendeurs diffusent leur caméra directement sur la plateforme, depuis leur téléphone ou ordinateur.' },
            { icon: <Users className="h-5 w-5" />, title: 'Communauté locale', text: 'Une plateforme pensée pour le Sénégal — paiement Wave et Orange Money, langues FR/EN.' },
            { icon: <ShieldCheck className="h-5 w-5" />, title: 'Vendeurs vérifiés', text: 'Chaque vendeur est validé par l\'équipe avant de pouvoir lancer un live.' },
            { icon: <Flame className="h-5 w-5" />, title: 'Anti-snipe', text: 'Les 10 dernières secondes se prolongent à chaque nouvelle enchère — pas de coup fourré.' },
            { icon: <Users className="h-5 w-5" />, title: 'Chat & réactions', text: 'Interagissez avec le vendeur et les autres acheteurs pendant le live.' },
          ].map((c, i) => (
            <div key={i} className="card-elev rounded-2xl p-5">
              <span className="h-10 w-10 grid place-items-center rounded-xl bg-rose-500/15 text-rose-400">{c.icon}</span>
              <div className="mt-3 font-display font-bold text-lg">{c.title}</div>
              <p className="mt-1 text-sm text-slate-400">{c.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 card-elev rounded-3xl p-8 text-center">
          <h2 className="font-display text-2xl sm:text-3xl font-extrabold">Prêt à lancer votre premier live ?</h2>
          <p className="mt-2 text-slate-400 max-w-xl mx-auto">Créez un compte vendeur, obtenez la validation de l'équipe, et diffusez en quelques minutes.</p>
          <div className="mt-5 flex flex-wrap gap-3 justify-center">
            <Link to="/register" data-testid="about-register-btn"
              className="px-6 py-3 rounded-xl btn-brand text-white font-bold">Devenir vendeur</Link>
            <Link to="/contact" data-testid="about-contact-btn"
              className="px-6 py-3 rounded-xl border border-slate-700 text-slate-100 hover:bg-slate-800 font-bold">Nous contacter</Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
